module.exports = __webpack_public_path__ + "static/01-0f7b1a47250f1e9673ea41f7e879d77c.png";